// @core/api/endpoints/authn/get_open_id_configuration.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetOpenIDConfigurationResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Get OpenID Connect discovery configuration
 * Returns the OpenID Connect discovery document containing issuer information, supported endpoints, and capabilities. Used by OIDC clients for automatic configuration.
 * @public This endpoint does not require authentication
 */
export async function GetOpenIDConfiguration(
  params?: {
  },
  options?: RequestOptions
): Promise<GetOpenIDConfigurationResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/.well-known/openid-configuration`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<GetOpenIDConfigurationResponse>(requestPath, { ...requestOptions, params });
}
